import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
          margin: theme.spacing(6),
        },
      },
      paper1: {
        padding: theme.spacing(5),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      },
  paper: {
    padding: theme.spacing(0),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  date: {
    width: 'auto',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
  },margin: {
    margin: theme.spacing(1),
  },
}));

function View(props) {
    const classes = useStyles();

    return (
        <div className={classes.root} style={{"max-width":"600px","margin-top":"10%"}}>
        <Paper className={classes.paper1} elevation={3}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
          id="outlined-full-width"
          label="Email"
          placeholder="Enter your mail id"
          helperText="mail will be send to this id"
          fullWidth 
          name="email" 
          onChange={props.handleChange('email')}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
        />
        </Grid>

        <Grid item xs={12} sm={6}>
        <FormControl className={classes.margin}>
        <InputLabel htmlFor="input-with-icon-adornment">PIN Code</InputLabel>
        <Input
          id="input-with-icon-adornment"
          name="pin" 
          onChange={props.handleChange('pin')}
          startAdornment={
            <InputAdornment position="start">
              <AccountCircle />
            </InputAdornment>
          }
        />
      </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
        <FormControl className={classes.margin}>
        <TextField
        id="date"
        label="Date"
        type="date"
        name="date" 
        onChange={props.handleChange('date')}
        defaultValue="yyyy-MM-dd"
        className={classes.date}
        InputLabelProps={{
          shrink: true,
        }}
      />
      </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
        <Paper elevation={0} className={classes.paper}>Select your Age-Group</Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
        <RadioGroup aria-label="Age" name="age" onChange={props.handleChange('age')}>
        <FormControlLabel value="18" control={<Radio />} label="18 to 44" />
        <FormControlLabel value="45" control={<Radio />} label="45+" />
      </RadioGroup>
        </Grid>
        <Grid item xs={12}>
        <Button variant="contained" onClick={props.handleSubmit} color="primary">
         Submit
        </Button>
         </Grid>
      </Grid>
      </Paper>
    </div>
    )
}

export default View
